import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { SEARCH_FIELD_BOX } from '../../../styles/constants';

export const useStyles = makeStyles<{ mode: 'light' | 'dark' }>()(
  (theme, { mode }) => ({
    searchInputRoot: {
      width: '100%',

      '& .MuiOutlinedInput-root': {
        height: SEARCH_FIELD_BOX,
        backgroundColor:
          mode === 'light'
            ? theme.palette.input.main
            : theme.palette.input.dark,
        color: theme.palette.input.contrastText,
        '& fieldset': {
          borderColor: theme.palette.input.dark,
        },
        '&:hover fieldset': {
          borderColor: theme.palette.input.dark,
        },
        '&.Mui-focused fieldset': {
          borderColor: theme.palette.primary.main,
        },
      },
    },
    searchInput: {
      // backgroundColor:
      //   mode === 'light' ? theme.palette.input.main : theme.palette.input.dark,
      // borderRadius: '10px',
      // '& .MuiInputBase-input': {
      //   color: theme.palette.input.contrastText,
      // },
    },
    searchIcon: {
      paddingLeft: 8,
      width: 'unset',
    },
  }),
);
